import React from "react";
import TabPayment from "./TabPayment";
import { Button, Modal, Tabs, Tab } from "react-bootstrap";

function modalPayment({ handleShowModal, isShowModal }) {
  return (
    <Modal show={isShowModal} size="lg" id="modalListenForPassword">
      <Modal.Body className="text-center">
        <Tabs>
          <Tab eventKey="Payment" title="Select the payment">
            <TabPayment />
          </Tab>
          {/* <Tab eventKey="Code" title="Enter the code">
            <TabCode />
          </Tab> */}
        </Tabs>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="buttons__close"
          onClick={() => {
            handleShowModal(0, "modalPayment");
          }}
        >
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default modalPayment;
